import { render, staticRenderFns } from "./FeedStory.vue?vue&type=template&id=60d7725a&scoped=true"
import script from "./FeedStory.vue?vue&type=script&lang=js"
export * from "./FeedStory.vue?vue&type=script&lang=js"
import style0 from "./FeedStory.vue?vue&type=style&index=0&id=60d7725a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d7725a",
  null
  
)

export default component.exports